const reducer = state => ({
  ...state,
  showExpiredOffersModal: true,
});

export default reducer;
